<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="900"
            tabindex="-1"
            role="dialog"
            transition="v-expand-y-transition"
            content-class="rounded-lg"
            persistent
        >
            <v-card
                class="elevation-12"
                max-width="900px"
                transition="v-expand-y-transition"
            >
                <v-container class="pa-7">
                    <h2 class="text-center mb-6 primary--text">
                        Welcome To Kaoshi
                    </h2>

                    <p class="mb-6">
                        Before you start, kindly watch the video below to understand how best Kaoshi can serve you
                    </p>

                    <video
                        v-if="show && videoSrc"
                        style="width: 100%;"
                        controls
                        autoplay
                    >
                        <source
                            :src="videoSrc"
                            type="video/mp4"
                        >
                        Sorry, your browser doesn't support embedded videos.
                    </video>

                    <v-card-actions class="justify-center mt-6">
                        <v-btn
                            color="primary"
                            class="white--text rounded-lg mb-3"
                            depressed
                            large
                            dark
                            @click="show = false"
                        >
                            Continue
                        </v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        accountOfficer() {
            return this.$_user.accountOfficer || null;
        },
        videoSrc() {
            if (!this.accountOfficer) return null;
            const { tag: accountOfficerTag } = this.accountOfficer;
            const accountType = this.$_user.can_post_offers ? 'poster' : 'matcher';

            return `https://s3.amazonaws.com/files.kaoshinetwork.com/videos/intro/${accountOfficerTag} Account Officer (${accountType} Video).mp4`;
        },
    },
};
</script>
